var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(String(_vm.data))+" "),_c('c-comp',{attrs:{"value":_vm.dsf},on:{"change":function (newValue) { _vm.dsf = newValue; }},model:{value:(_vm.dsf),callback:function ($$v) {_vm.dsf=$$v},expression:"dsf"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }